import React from "react";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _uniqueId from "lodash/uniqueId";
import { UncontrolledTooltip } from "reactstrap";

const TooltipIcon = ({ message }) => {
  const iconId = _uniqueId("icon-");
  return (
    <>
      <FontAwesomeIcon icon={faQuestionCircle} id={iconId} />
      <UncontrolledTooltip target={iconId || ""}>{message}</UncontrolledTooltip>
    </>
  );
};

export default TooltipIcon;
